import { getCountry } from '@iwIntlProvider/CountryProvider';
import { fetchGetCreditCardOffers } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';

export const useGetCreditCardOffer = (
    {
        suspense = false
    }: {
        suspense: boolean;
    } = { suspense: false }
) => {
    const stateKey = useStateKey();

    const {
        data: creditCardOffer,
        isLoading: getCreditCardOfferLoading,
        isError: getCreditCardOfferError
    } = useQuery({
        queryKey: ['credit_card_offer', stateKey],
        queryFn: (): ReturnType<typeof fetchGetCreditCardOffers> => {
            if (getCountry() === 'UK') {
                return fetchGetCreditCardOffers({
                    stateKey
                });
            }

            // eslint-disable-next-line compat/compat
            return Promise.resolve({ data: {} });
        },
        select: (data) => data.data,
        suspense
    });

    const isCreditCardOfferExpired =
        creditCardOffer &&
        creditCardOffer.timeout &&
        new Date() > new Date(creditCardOffer.timeout);

    return {
        creditCardOffer,
        isCreditCardOfferExpired,
        getCreditCardOfferLoading,
        getCreditCardOfferError
    };
};
